import { jsx as s } from "react/jsx-runtime";
import f, { SocialMediaDialog as g } from "../components/confirm/Confirm.js";
import { CONFIRM_ROOT as c } from "./popups.js";
var e, i;
const l = async (r, o, n) => {
  const t = new Promise((a, m) => {
    e = a, i = m;
  });
  return c.render(
    /* @__PURE__ */ s(f, { title: r, message: o, acceptConfirm: e, cancelConfirm: i, variant: n })
  ), t;
}, v = async (r, o = "", n) => {
  await l(o, r, n);
}, w = async (r, o) => {
  const n = new Promise((t, a) => {
    i = a;
  });
  return c.render(
    /* @__PURE__ */ s(g, { title: r, message: o, acceptConfirm: e, cancelConfirm: i })
  ), n;
}, y = async (r, o = "") => {
  await w(o, r);
};
export {
  v as showConfirm,
  y as showDataDialog
};
